/**
 * Mixin for handling metadata from various sources (short, preview, seedData).
 */
export default {
  computed: {
    /**
     * Extracts metadata from the consolidated seed data.
     * @returns {Object} The metadata object or an empty object if not found.
     */
    seedDataMetadata () {
      const shortData = this.$store.getters['short/getShort']
      const previewData = this.$store.getters['preview/getPreview']
      const seedDataStore = this.$store.getters['seedData/getSeedData']

      // Priority 1: metadata from short
      if (shortData?.data?.seedData?.metadata) {
        return shortData.data.seedData.metadata
      }

      // Priority 2: metadata from preview
      if (previewData?.data?.seedData?.metadata) {
        return previewData.data.seedData.metadata
      }

      // Priority 3: metadata directly from seedData
      if (seedDataStore?.metadata) {
        return seedDataStore.metadata
      }

      return {}
    },

    /**
     * Retrieves the main image URL from metadata if it exists and is valid (contains 'http').
     * @returns {string} The main image URL or an empty string.
     */
    mainImageFromMetadata () {
      const mainImage = this.seedDataMetadata && this.seedDataMetadata._mainImage
      return (mainImage && mainImage.includes('http')) ? mainImage : ''
    },
    /**
     * Retrieves the footer image URL from metadata if it exists and is valid (contains 'http').
     * @returns {string} The footer image URL or an empty string.
     */
    footerImageFromMetadata () {
      const footerImage = this.seedDataMetadata && this.seedDataMetadata._footerImage
      return (footerImage && footerImage.includes('http')) ? footerImage : ''
    },

    /**
     * Retrieves the current survey from the store.
     * @returns {Object} The current survey.
     */
    currentSurvey () {
      return this.$store.getters['survey/getSurvey']
    },

    /**
     * Retrieves the default footer image from the current survey.
     * @returns {string} The default footer image URL or an empty string.
     */
    defaultFooterImage () {
      return this.currentSurvey.images && this.currentSurvey.images.length > 1 ? this.currentSurvey.images[1].value : ''
    },

    /**
     * Retrieves the footer image from metadata or returns a default image if not available.
     * @returns {string} The resolved image URL.
     */
    returnFooterImageFromMetadata () {
      return this.footerImageFromMetadata || this.defaultFooterImage
    }
  },
  methods: {
    /**
     * Gets the main image from metadata or returns a default image if not available.
     * @param {string} defaultImage - The default image URL to return if no metadata image is found.
     * @returns {string} The resolved image URL.
     */
    getMainImageFromMetadata (defaultImage) {
      return this.mainImageFromMetadata || defaultImage
    }
  }
}
